// /onboarding — route-redirection hub.  Routes users into the 4-step flow
// based on their state (per W2 §4.3 + Q17, 4 steps per W36.1 profile spec
// §3.4).  Already-authenticated users can short-circuit to dashboard when
// their pair + first diary are both present.

import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth/AuthProvider";

export function OnboardingPage() {
  const { user, pairId, status } = useAuth();

  // No rendered UI — this is a pure redirect hub. data-testid on the
  // null branch lets E2E wait for the redirect to settle.
  if (status === "loading") {
    return <div data-testid="onboarding-loading" aria-busy="true" />;
  }
  if (!user) {
    // Not signed in: bounce to welcome / login.
    return <Navigate to="/login" replace data-testid="onboarding-redirect-to-login" />;
  }
  if (!user.email_verified_at && user.email) {
    // Email not yet verified; nudge them to check inbox but don't block.
    // (The actual verify-email flow is reachable from the dashboard.)
    return <Navigate to="/dashboard" replace data-testid="onboarding-redirect-pending-verify" />;
  }
  // W36.1: the profile step sits **before** pairing, so a member who has no
  // birthday yet is sent there rather than to /pair. That is the whole point
  // of the ordering — `pair.confirmed` then fans the anniversary out by
  // itself, instead of the backfill CTA becoming the normal route.
  if (!user.birthday) {
    return <Navigate to="/onboarding/profile" replace data-testid="onboarding-redirect-to-profile" />;
  }
  if (!pairId) {
    return <Navigate to="/pair" replace data-testid="onboarding-redirect-to-pair" />;
  }
  return (
    <Navigate
      to="/onboarding/first-diary"
      replace
      data-testid="onboarding-redirect-to-first-diary"
    />
  );
}
